import { Purchase } from "features/purchase/types";

export type Attachment = {
	path: string;
	name: string;
	url: string;
	type: string;
};
export type Language<T = string> = {
	en: T;
	km: T;
	zh: T;
};

export enum IMPORT_CAR_STATUS {
	PUBLISH = "publish",
	UNPUBLISH = "unpublish",
}
export interface ImportCar {
	_id?: string;
	updatedAt?: Date;
	createdAt?: Date;
	name: Language;
	merchant: number;
	description?: string;
	cover: string;
	publicCoverImage: string;
	colors: string[];
	state?: string;
	bodyType?: string;
	seat?: string;
	transmission?: string;
	fuel?: string;
	fuelConsumption?: number;
	enginePower?: number;
	enginePowerUnit?: string;
	engineSize?: number;
	engineSizeUnit?: string;
	distanceDriven?: number;
	manufactureYear?: number;
	price: number;
	minPrice: number;
	status?: IMPORT_CAR_STATUS;
	origin: string;
	updatedBy?: any;
	note?: string;
	doors?: number;
	extraData?: any;
	carStore: any;
	additionalAttributes?: Record<string, any>;
	merchantInfo: {
		id: number;
		fullName: string;
	};
}
export enum FORM_REQUEST_TYPE {
	CANDIDATE = "candidate",
	CAR_REQUEST = "car_request",
	SERVICE_REQUEST = "service_request",
	PRODUCT_REQUEST = "product_request",
	CONTACT = "contact",
	INVESTMENT = "investment",
	CAR_CARE_SERVICE = "car_wash_service",
	SELL_YOUR_CAR = "sell_your_car",
	IMPORT_CAR = "import_car",
}
export enum FORM_REQUEST_STATUS {
	NEW = "new",
	PROCESSING = "processing",
	SOLVED = "solved",
}

export enum FORM_REQUEST_DISCOUNT_TYPE {
	PERCENT = "percent",
	PRICE = "price",
}

export interface CarAttribute {
	brand: {
		name: {
			[key: string]: string;
		};
		brandId: number;
	};
	images: string[];
	internalImages: string[];
	video: string;
	manufactureYear: number;
	model: {
		name: {
			[key: string]: string;
		};
		modelId: number;
	};
	state: string;
	transmission?: string;
	color?: string;
	fuel?: string;
	mileage?: string;
	isChecked?: boolean;
	origin?: string;
	bodyType?: string;
	taxType?: string;
	sellingPrice?: number;
	isNegotiation?: boolean;
	discountValue?: number;
	discountType?: string;
	cover?: string;
	name?: string;
	carId?: number;
}
export interface FormRequest {
	_id: string;
	name: string;
	phoneNumber: string;
	email?: string | undefined;
	description?: string;
	type?: FORM_REQUEST_TYPE;
	status?: FORM_REQUEST_STATUS;
	refId: any;
	attribute?: {
		attachment?: string;
		note?: string;
		attachments?: Attachment[];
	};
	createdAt?: Date;
	source?: Source;
	carRegistrationAttribute?: CarAttribute;
	carAttribute?: CarAttribute;
	importCar?: ImportCar;
	resolvedData?: {
		refId: number;
		type: string;
	};
	userId?: number;
	purchaseOrder?: Purchase;
	telegram?: string;
	planToSell?: string;
	carOwner?: {
		id?: number;
		fullName?: string;
	};
}
interface Source {
	name?: string;
	type?: string;
	description?: string;
	language?: string;
	service?: Service;
}
interface Service {
	id?: number;
}
export interface BaseQuery {
	skip: number;
	take: number;
	name?: string | null;
}
export interface ServiceQueryParams extends BaseQuery {
	status: string;
	language: string;
}
export interface FormRequestQueryParams extends BaseQuery {
	type?: FORM_REQUEST_TYPE | null;
	status?: FORM_REQUEST_STATUS | null;
	types?: FORM_REQUEST_TYPE[];
	startDate?: string | null;
	endDate?: string | null;
	refId?: any;
}
